<template>
  <div class="form-wrapper">
    <main class="form-signin shadow-lg">
      <div class="text-center px-4">
        <div>
          <a class="title" href="/">
            <h1 class="h2 mt-4 mb-3 text-center">
              PREFERE PLUS
            </h1>
          </a>
        </div>
      </div>

      <h3 class="h3 mt-4 mb-4 text-center text-black"><u>Inscription</u></h3>

      <div class="container-fluid">
        <div class="row justify-content-center">
          <VeeForm
            class="col-sm-10"
            v-slot="{ handleSubmit }"
            :validation-schema="schema"
            as="div"
          >
            <div
              class="alert alert-danger d-none"
              id="alertError"
              role="alert"
            ></div>
            <form @submit="handleSubmit($event, onSubmit)" class="registration-form">
              <div class="card mb-4">
                <div class="card-body">
                  <h5 class="card-title mb-4">Informations personnelles</h5>
                  
                  <fieldset class="row mb-4">
                    <legend class="col-form-label col-sm-2 pt-0">Genre</legend>
                    <div class="col-sm-10 ps-sm-0 ps-4">
                      <div class="form-check form-check-inline">
                        <Field
                          class="form-check-input"
                          type="radio"
                          name="radioGender"
                          id="radioMan"
                          value="M"
                          v-model="gender"
                        />
                        <label class="form-check-label" for="radioMan">
                          Homme
                        </label>
                      </div>
                      <div class="form-check form-check-inline">
                        <Field
                          class="form-check-input"
                          type="radio"
                          name="radioGender"
                          id="radioWoman"
                          value="F"
                          v-model="gender"
                        />
                        <label class="form-check-label" for="radioWoman">
                          Femme
                        </label>
                      </div>
                    </div>
                  </fieldset>

                  <div class="row">
                    <div class="col-md-6 mb-3">
                      <label for="last_name" class="form-label">Nom</label>
                      <Field
                        name="last_name"
                        type="text"
                        label="nom"
                        v-slot="{ field, errorMessage }"
                      >
                        <input
                          id="last_name"
                          v-bind="field"
                          placeholder="Entrer votre nom ici."
                          class="form-control"
                          :class="{ 'is-invalid': errorMessage }"
                        />
                      </Field>
                      <ErrorMessage
                        name="last_name"
                        as="div"
                        class="invalid-feedback"
                      />
                    </div>
                    <div class="col-md-6 mb-3">
                      <label for="first_name" class="form-label">Prénom</label>
                      <Field
                        name="first_name"
                        type="text"
                        label="prénom"
                        v-slot="{ field, errorMessage }"
                      >
                        <input
                          id="first_name"
                          v-bind="field"
                          placeholder="Entrer votre prénom ici."
                          class="form-control"
                          :class="{ 'is-invalid': errorMessage }"
                        />
                      </Field>
                      <ErrorMessage
                        name="first_name"
                        as="div"
                        class="invalid-feedback"
                      />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6 mb-3">
                      <label for="phone" class="form-label">Téléphone</label>
                      <Field
                        name="phone"
                        type="text"
                        label="téléphone"
                        v-slot="{ field, errorMessage }"
                      >
                        <input
                          id="phone"
                          v-bind="field"
                          placeholder="Entrer votre numéro de téléphone ici."
                          class="form-control tel-input"
                          :class="{ 'is-invalid': errorMessage }"
                        />
                        <ErrorMessage
                          name="phone"
                          as="div"
                          class="invalid-feedback"
                          :class="{ 'd-block': errorMessage }"
                        />
                      </Field>
                    </div>
                    <div class="col-md-6 mb-3">
                      <label for="emailInput" class="form-label">Email</label>
                      <Field
                        name="email"
                        type="email"
                        v-slot="{ field, errorMessage }"
                      >
                        <input
                          id="emailInput"
                          v-bind="field"
                          v-model="email"
                          placeholder="Entrer votre email ici."
                          class="form-control"
                          :class="{ 'is-invalid': errorMessage }"
                        />
                      </Field>
                      <ErrorMessage name="email" as="div" class="invalid-feedback" />
                    </div>
                  </div>
                </div>
              </div>

              <div class="card mb-4">
                <div class="card-body">
                  <h5 class="card-title mb-4">Sécurité</h5>
                  
                  <div class="mb-3">
                    <label for="password" class="form-label">Mot de passe</label>
                    <div class="input-group">
                      <Field
                        name="password"
                        type="password"
                        label="mot de passe"
                        v-slot="{ field, errorMessage }"
                      >
                        <input
                          id="password"
                          :type="[showPassword ? 'text' : 'password']"
                          v-bind="field"
                          placeholder="Entrer votre mot de passe ici."
                          class="form-control"
                          :class="{ 'is-invalid': errorMessage }"
                          aria-describedby="btnGroupAddon1"
                        />
                        <div
                          class="input-group-text"
                          id="btnGroupAddon1"
                          title="Afficher/Cacher"
                        >
                          <font-awesome-icon
                            icon="eye"
                            v-if="!showPassword"
                            @click="showPassword = !showPassword"
                          />
                          <font-awesome-icon
                            icon="eye-slash"
                            v-if="showPassword"
                            @click="showPassword = !showPassword"
                          />
                        </div>
                      </Field>
                      <ErrorMessage
                        name="password"
                        as="div"
                        class="invalid-feedback"
                      />
                    </div>
                  </div>

                  <div class="mb-3">
                    <label for="confirmedPassword" class="form-label">Confirmer votre mot de passe</label>
                    <div class="input-group">
                      <Field
                        name="confirmedPassword"
                        label="confirmer mot de passe"
                        v-slot="{ field, errorMessage }"
                      >
                        <input
                          id="confirmedPassword"
                          :type="[showConfPassword ? 'text' : 'password']"
                          v-bind="field"
                          placeholder="Re-saisissez le mot de passe."
                          class="form-control"
                          :class="{ 'is-invalid': errorMessage }"
                          aria-describedby="btnGroupAddon2"
                        />
                        <div
                          class="input-group-text"
                          id="btnGroupAddon2"
                          title="Afficher/Cacher"
                        >
                          <font-awesome-icon
                            icon="eye"
                            v-if="!showConfPassword"
                            @click="showConfPassword = !showConfPassword"
                          />
                          <font-awesome-icon
                            icon="eye-slash"
                            v-if="showConfPassword"
                            @click="showConfPassword = !showConfPassword"
                          />
                        </div>
                      </Field>
                      <ErrorMessage
                        name="confirmedPassword"
                        as="div"
                        class="invalid-feedback"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div class="mb-4">
                <CguCheckbox name="checkBox"></CguCheckbox>
              </div>

              <button class="w-100 btn btn-lg btn-primary" type="submit">
                S'inscrire
              </button>
            </form>
          </VeeForm>
        </div>
      </div>

      <div class="text-center fs-6 mt-4">
        <div class="mb-3 text-muted">
          <ul class="list-inline">
            <li class="list-inline-item">
              <router-link to="/login">Connexion</router-link>
            </li>
            <li class="list-inline-item">
              <router-link to="/">Accueil</router-link>
            </li>
          </ul>
        </div>
        <img src="../assets/img/logo.png" height="80" alt="" />
        <p class="mb-1 text-muted">
          &copy; 2025 PREFERE PLUS. Tous droits reservés.
        </p>
      </div>
    </main>
  </div>
</template>

<script>
import CguCheckbox from "../components/CguCheckbox.vue";
import { Form as VeeForm, Field, ErrorMessage } from "vee-validate";
import { defineRule } from "vee-validate";
import { required, min, confirmed } from "@vee-validate/rules";
import "intl-tel-input/build/css/intlTelInput.css";
import intlTelInput from "intl-tel-input";

var iti;

import { library } from "@fortawesome/fontawesome-svg-core";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons";
library.add(faEye, faEyeSlash, faExternalLinkAlt);

defineRule("required", required);

defineRule("custom_email", (value) => {
  if (!value || !value.length) {
    return true;
  }
  const pattern =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (!pattern.test(value.trim())) {
    return "Le champ email doit être une adresse e-mail valide";
  }
  return true;
});

defineRule("min", min);
defineRule("confirmed", confirmed);

defineRule("telephone", (value) => {
  if (!value || !value.length) {
    return true;
  }

  try {
    const countryData = iti.getSelectedCountryData();
    const phoneNumber = iti.getNumber();
    
    if (countryData.iso2.toLowerCase() === 'bj') {
      const nationalNumber = phoneNumber.replace(`+${countryData.dialCode}`, '').replace(/\D/g, '');
      
      if (nationalNumber.length === 8) {
        return true;
      } else if (nationalNumber.length === 10) {
        if (nationalNumber.startsWith('0')) {
          return true;
        }
        return "Les numéros à 10 chiffres doivent commencer par 0.";
      }
      return "Pour le Bénin, le numéro doit contenir 8 chiffres ou 10 chiffres commençant par 0.";
    } 
    else {
      if (!iti.isValidNumber()) {
        return "Le numéro de téléphone n'est pas valide.";
      }
      return true;
    }
  } catch (error) {
    console.error('Erreur de validation du téléphone:', error);
    return "Le format du numéro de téléphone n'est pas valide.";
  }
});

import { setLocale } from "@vee-validate/i18n";
import { configure } from "vee-validate";
import { localize } from "@vee-validate/i18n";
import fr from "@vee-validate/i18n/dist/locale/fr.json";
configure({
  generateMessage: localize({
    fr,
  }),
});
setLocale("fr");

export default {
  name: "Login",
  inject: ["ToastSuccess", "ToastError", "currentYearUrl"],
  components: {
    VeeForm,
    Field,
    ErrorMessage,
    CguCheckbox,
    FontAwesomeIcon,
  },
  mounted() {
    let input = document.querySelector("#phone");
    iti = intlTelInput(input, {
      preferredCountries: ["bj", "bf", "ci", "dj", "ne", "sn", "tg", "ga"],
      initialCountry: "bj",
      utilsScript:
        "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.19/js/utils.min.js",
    });
    document.getElementById("alertError").textContent = "";
    document.getElementById("alertError").classList.add("d-none");
    fetch(this.currentYearUrl)
      .then((result) => {
        result.text().then(function (text) {
          document.getElementById("currentYear").textContent = text;
        });
      })
      .catch(() => {
        document.getElementById("currentYear").textContent = "2023";
      });
  },
  data() {
    const schema = {
      first_name: "required",
      last_name: "required", 
      phone: "required|telephone",
      email: "required|custom_email",
      password: "required",
      confirmedPassword: "required|confirmed:@password",
      checkBox: "required",
      radioGender: "required"
    };
    return {
      schema,
      email: "",
      showPassword: false,
      showConfPassword: false,
      gender: "M"
    };
  },
  methods: {
    onSubmit(values, actions) {
      try {
        const phoneNumber = iti.getNumber();
        const countryData = iti.getSelectedCountryData();
        
        if (countryData.iso2.toLowerCase() === 'bj') {
          const nationalNumber = phoneNumber.replace(`+${countryData.dialCode}`, '').replace(/\D/g, '');
          
          if (nationalNumber.length === 10 && nationalNumber.startsWith('0')) {
            values.phone = `+${countryData.dialCode}${nationalNumber}`;
          } else {
            values.phone = phoneNumber;
          }
        } else {
          values.phone = phoneNumber;
        }
        
        values.userType = "candidat";
        
        console.log('Numéro de téléphone formaté:', values.phone);
        console.log('Valeurs à envoyer:', values);

        this.$http
          .post("users", values)
          .then((response) => {
            this.ToastSuccess.fire({
              title: "Votre compte a été créé avec succès !",
            });
            localStorage.setItem("token", response.data.access_token);
            localStorage.setItem(
              "email_verified",
              response.data.email_verified
            );
            localStorage.setItem("email", response.data.email);
            localStorage.setItem("firstName", response.data.first_name);
            localStorage.setItem("lastName", response.data.last_name);
            localStorage.setItem("userId", response.data.id);

            this.$http.defaults.headers.common["Authorization"] =
              localStorage.getItem("token")
                ? "Bearer " + localStorage.getItem("token")
                : "";

            // Conserver la destination d'origine (lien invitation, offre, etc.)
            // sinon rediriger par defaut vers /job-offers apres verification email
            const redirectParam = this.$route.query.redirect || "/job-offers";
            localStorage.setItem("post_auth_redirect", redirectParam);

            if (localStorage.getItem("token")) {
              this.$router.push({ name: "EmailVerification" });
            }
          })
          .catch((error) => {
            console.error('Erreur complète:', error);
            if (error.response?.status === 422) {
              console.error('Erreurs de validation:', error.response.data.errors);
              this.ToastError.fire({
                title: "Veuillez bien remplir le formulaire et réessayez.",
              });

              let errors = error.response.data.errors;
              for (const key in errors) {
                if (Object.prototype.hasOwnProperty.call(errors, key)) {
                  const element = errors[key];
                  actions.setFieldError(key, element);
                }
              }
            } else {
              this.ToastError.fire({
                title: "Une erreur s'est produite, veuillez réessayer.",
              });
            }
          });
      } catch (error) {
        console.error('Erreur lors de la soumission:', error);
        this.ToastError.fire({
          title: "Une erreur s'est produite lors de la validation du numéro de téléphone.",
        });
      }
    },
  },
};
</script>

<style scoped>
body {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8f9fa;
}

.title {
  text-decoration: none;
}

.form-control {
  line-height: 1.5;
  padding: 0.75rem 1rem;
  border-radius: 8px;
}

.btn-primary {
  background-color: #2596be;
  border-color: #2596be;
  transition: all 0.3s ease;
}

.btn-primary:hover {
  background-color: #1d7a9c;
  border-color: #1d7a9c;
  transform: translateY(-2px);
}

.form-wrapper {
  width: 100%;
  max-width: 900px;
  margin: auto;
  padding: 20px;
  font-size: 16px;
}

.form-signin {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 12px;
  padding: 40px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.1);
}

.card {
  border: none;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
}

.card-title {
  color: #2596be;
  font-weight: 600;
}

.input-group-text {
  background-color: #f8f9fa;
  border-left: none;
  cursor: pointer;
}

.input-group-text svg {
  color: #80828B;
  transition: color 0.3s ease;
}

.tel-input {
  padding-left: 50px !important; /* Add more left padding to prevent flag overlap */
}

.input-group-text:hover svg {
  color: #2596be;
}

@media (max-width: 575.98px) {
  .form-wrapper {
    padding: 10px;
  }

  .form-signin {
    padding: 20px;
  }
}

h1, h3 {
  color: #2596be;
  font-weight: 600;
}

.form-label {
  color: #495057;
  font-weight: 500;
  margin-bottom: 0.5rem;
}

.btn-lg {
  padding: 0.75rem 1.5rem;
  font-weight: 600;
  border-radius: 8px;
}

a {
  color: #2596be;
  text-decoration: none;
  transition: color 0.3s ease;
}

a:hover {
  color: #e95d16;
}

.registration-form {
  animation: fadeIn 0.5s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
